import { createAsyncThunk } from '@reduxjs/toolkit';
import { AICoachGoalsApi, GetAICoachGoalsResponse } from 'api/AICoachGoalsApi';
import { AICoachGoalItem } from 'api/LoanOfferApi';

export const createCreateAICoachGoalsThunk = (api: AICoachGoalsApi) =>
  createAsyncThunk(
    'yourGoal/createAICoachGoals',
    async ({ applicationId, goals }: { applicationId: string; goals: AICoachGoalItem[] }, thunkApi) => {
      try {
        const createdGoals: GetAICoachGoalsResponse = await api.createAICoachGoals(applicationId, goals);
        return createdGoals;
      } catch (error: any) {
        const payload = { ...(error.response?.data ?? {}), statusCode: error.responseStatus ?? 0 };
        return thunkApi.rejectWithValue(payload);
      }
    },
  );
